import React from 'react'
import { GAME_DESCRIPTION } from './CONTENT'

interface GameDescriptionProps {
  gameInfo: {
    minBet: string
    maxBet: string
    currency: string
    precision: number
    game_settings: {
      coefs?: string[]
    } | null
  }
}

export default function GameDescription({ gameInfo }: GameDescriptionProps) {

  const getMaxWin = () => {
    const coefs = gameInfo.game_settings?.coefs
    const maxBet = gameInfo.maxBet
    if (!coefs?.length || !maxBet) return '0'
    
    const maxCoefficient = Math.max(...coefs.map(Number))
    return String(Number(maxBet) * maxCoefficient)
  }

  return (
    <div>
      <h3>{GAME_DESCRIPTION.title}</h3>
      {GAME_DESCRIPTION.description.map((text, id) => (
        <p key={id}>{text}</p>
      ))}
      <div style={{ marginTop: '15px' }}>
        <p>
          The max win is {`${gameInfo.currency} ${Number(gameInfo.maxBet) * parseFloat(getMaxWin())}`} of your bet
        </p>
        <p>
          Maximum Bet: {`${gameInfo.currency} ${gameInfo.maxBet}`} Minimum Bet:{" "}
          {`${gameInfo.currency} ${gameInfo.minBet}`}
        </p>
      </div>
    </div>
  )
}
